module.exports = __webpack_public_path__ + "img/PS.3efc9b3d.svg";